export default {
  labels: {
    username: 'Username',
    oldPassword: 'Old Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    resetPassword: 'Reset Password',
  },
  placeholders: {
    username: 'Enter your username',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
  },
  buttons: {
    login: 'Login',
    save: 'Save',
  },
  title: {
    changePassword: 'Change Password',
  },
};
